var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnknown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    style: {
      enableBackground: "new 0 0 150 150"
    },
    xmlSpace: "preserve",
    width: 150,
    height: 150,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E6E6E6;}\r\n\t.st1{fill:#999999;}\r\n\t.st2{fill:#666666;}\r\n\t.st3{fill:#FFFFFF;}\r\n\t.st4{fill:none;}\r\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "unknown") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 75,
    cy: 75,
    r: 42.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75,119.1c-24.4,0-44.1-19.7-44.1-44.1S50.6,30.9,75,30.9s44.1,19.7,44.1,44.1l0,0 C119.1,99.1,99.4,118.8,75,119.1z M75,33.8c-22.6,0-41.2,18.5-41.2,41.2s18.5,41.2,41.2,41.2s41.2-18.5,41.2-41.2 C116.2,52.1,97.9,33.8,75,33.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M89.7,47.1H60.3c-4.1,0-7.4,3.2-7.4,7.4v41.2c0,4.1,3.2,7.4,7.4,7.4h29.4c4.1,0,7.4-3.2,7.4-7.4V54.4 C97.1,50.3,93.8,47.1,89.7,47.1z M63.2,97.1c-2.4,0-4.4-2.1-4.4-4.4c0-2.4,2.1-4.4,4.4-4.4c2.4,0,4.4,2.1,4.4,4.4 C67.6,95,65.9,97.1,63.2,97.1L63.2,97.1z M86.8,97.1c-2.4,0-4.4-2.1-4.4-4.4c0-2.4,2.1-4.4,4.4-4.4c2.4,0,4.4,2.1,4.4,4.4 C91.2,95,89.4,97.1,86.8,97.1L86.8,97.1z M91.2,73.2c0,1.8-1.5,3.2-3.2,3.2H61.8c-1.8,0-3.2-1.5-3.2-3.2V55.9 c0-1.8,1.5-3.2,3.2-3.2h26.2c1.8,0,3.2,1.5,3.2,3.2V73.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 63.2,
    cy: 92.6,
    r: 4.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 86.8,
    cy: 92.6,
    r: 4.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M62.1,52.9h26.2c1.8,0,3.2,1.5,3.2,3.2v17.4c0,1.8-1.5,3.2-3.2,3.2H62.1c-1.8,0-3.2-1.5-3.2-3.2V56.2 C58.8,54.1,60.3,52.9,62.1,52.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    width: 150,
    height: 150
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknown);
export default __webpack_public_path__ + "static/media/unknown.dcbf3104a98237427756f3cc99255f99.svg";
export { ForwardRef as ReactComponent };